export const midiForOne = 1;
export const midiForTwo = 2;
export const midiForThree = 3;
export const midiForFour = 4;
export const midiForGo = 5;
export const midiForSet = 6;

interface ITimeSignatureCountInMap {
  [key: string]: number[];
}

export const timeSignatureCountInMap: ITimeSignatureCountInMap = {
  "2_2": [midiForOne, midiForTwo, midiForSet, midiForGo],
  "2_4": [midiForOne, midiForTwo, midiForSet, midiForGo],
  "2_8": [midiForOne, midiForTwo, midiForSet, midiForGo],
  "2_16": [midiForOne, midiForTwo, midiForSet, midiForGo],

  "3_2": [midiForOne, midiForTwo, midiForThree, midiForOne, midiForSet, midiForGo],
  "3_4": [midiForOne, midiForTwo, midiForThree, midiForOne, midiForSet, midiForGo],
  "3_8": [midiForOne, midiForTwo, midiForThree, midiForOne, midiForSet, midiForGo],
  "3_16": [midiForOne, midiForTwo, midiForThree, midiForOne, midiForSet, midiForGo],

  "6_2": [midiForOne, midiForTwo, midiForSet, midiForGo],
  "6_4": [midiForOne, midiForTwo, midiForSet, midiForGo],
  "6_8": [midiForOne, midiForTwo, midiForSet, midiForGo],
  "6_16": [midiForOne, midiForTwo, midiForSet, midiForGo],

  "9_2": [midiForOne, midiForTwo, midiForThree, midiForOne, midiForSet, midiForGo],
  "9_4": [midiForOne, midiForTwo, midiForThree, midiForOne, midiForSet, midiForGo],
  "9_8": [midiForOne, midiForTwo, midiForThree, midiForOne, midiForSet, midiForGo],
  "9_16": [midiForOne, midiForTwo, midiForThree, midiForOne, midiForSet, midiForGo],

  "4_2": [midiForOne, midiForTwo, midiForThree, midiForFour, midiForOne, midiForTwo, midiForSet, midiForGo],
  "4_4": [midiForOne, midiForTwo, midiForThree, midiForFour, midiForOne, midiForTwo, midiForSet, midiForGo],
  "4_8": [midiForOne, midiForTwo, midiForThree, midiForFour, midiForOne, midiForTwo, midiForSet, midiForGo],
  "4_16": [midiForOne, midiForTwo, midiForThree, midiForFour, midiForOne, midiForTwo, midiForSet, midiForGo],

};